import React from 'react';
import './ImpactMetrics.css';
import { theme } from '../../theme/designSystem';

import { metricsData } from '../../data/metricsData';

function ImpactMetrics() {
    return (
        <section className="impact-metrics" id="impact" style={{ backgroundColor: theme.secondary }}>
            <div className="impact-metrics--inner">
                <div className="impact-metrics--intro">
                    <span className="eyebrow eyebrow--center">Impact at Scale</span>
                    <h2 style={{ color: theme.primary }}>
                        Systems trusted in production, every day
                    </h2>
                </div>

                <div className="impact-metrics--container">
                    {metricsData.map((metric, index) => (
                        <div
                            key={metric.id}
                            className="impact-metric--card fade-in-up"
                            style={{
                                backgroundColor: theme.tertiary,
                                borderRadius: '14px',
                                animationDelay: `${index * 0.08}s`
                            }}
                        >
                            <div className="impact-metric--icon" style={{ color: theme.accent }}>
                                {metric.icon}
                            </div>
                            <div className="impact-metric--content">
                                <h2 style={{ color: theme.primary }}>{metric.value}</h2>
                                <p style={{ color: theme.textPrimary }}>{metric.label}</p>
                                {metric.detail && (
                                    <span className="impact-metric--detail" style={{ color: theme.textTertiary }}>
                                        {metric.detail}
                                    </span>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default ImpactMetrics;
